'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.formatPhone = formatPhone;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactNumberFormat = require('react-number-format');

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Выводит форматированный номер заказа и слаба
 */


function formatPhone(value) {
  value = value ? value.replace(/[^0-9]/g, '').substr(0, 11) : "";
  value = value ? value.split("").reduce(function (current, next, index) {
    current.push(next);
    return current;
  }, []) : [];
  return '+' + (value[0] || '#') + '(' + (value[1] || '#') + (value[2] || '#') + (value[3] || '#') + ')' + (value[4] || '#') + (value[5] || '#') + (value[6] || '#') + '-' + (value[7] || '#') + (value[8] || '#') + '-' + (value[9] || '#') + (value[10] || '#');
}

var NumberFormat = function (_NumberFormatProto) {
  _inherits(NumberFormat, _NumberFormatProto);

  function NumberFormat() {
    _classCallCheck(this, NumberFormat);

    return _possibleConstructorReturn(this, (NumberFormat.__proto__ || Object.getPrototypeOf(NumberFormat)).apply(this, arguments));
  }

  return NumberFormat;
}(_reactNumberFormat2.default);

var PhoneField = function (_Component) {
  _inherits(PhoneField, _Component);

  function PhoneField() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, PhoneField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = PhoneField.__proto__ || Object.getPrototypeOf(PhoneField)).call.apply(_ref, [this].concat(args))), _this2), _this2.valueToText = formatPhone, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(PhoneField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          onChange = _props.onChange,
          value = _props.value,
          other = _objectWithoutProperties(_props, ['name', 'onChange', 'value']);

      return _react2.default.createElement(NumberFormat, _extends({
        value: value || "",
        customInput: _TextField2.default,
        format: this.valueToText,
        removeFormatting: function removeFormatting(value) {
          return value ? value.replace(/^\+/, '').replace(/[^0-9]/g, '') : "";
        },
        onValueChange: function onValueChange(values, event) {
          var value = values.value;
          onChange && onChange({
            target: {
              name: name,
              value: value
            }
          });
        }
      }, other));
    }
  }]);

  return PhoneField;
}(_react.Component);

exports.default = PhoneField;